<template>
  <v-app>
    <v-main :style="{ background: $vuetify.theme.themes['light'].background }">
      <router-view></router-view>
    </v-main>
  </v-app>
</template>

<script>
export default {
  name: "App",

  data: () => ({
    //
  }),
};
</script>
